import React from "react"
import { Link, NavLink } from "react-router-dom"

const upperNavBar = (props) => {

    return (
        <>
            <div className="upperNavBar">
                <ul className="upperNavBarListItems">
                    <li className="nav-item">
                        <span className="masterPlanText">
                            <img src='/assets/images/mast.svg' /><NavLink className="nav-link masterplan" to="/navigator">Master Plan</NavLink>
                        </span>
                    </li>
                    {props.isSection === true && false ?
                        <li className="nav-item">
                            <a className="nav-link  section" href="projectSlection">Section</a>
                        </li> : null
                    }


                </ul>
            </div>
        </>
    )
}
export default upperNavBar
